
import React from 'react';
import { Button } from 'tea-component';
import { useIntl } from 'umi';

export default function EmailRegisterSuccess(props: any) {
  const { onBack } = props;
  const { formatMessage } = useIntl()
  return (
    <div className="login-cont-email--success">
      <div className='login-cont'>
        <div className='login-cont-title'>{formatMessage({ id: 'dbh_login_thankyou_register' })}</div>
        <div className='login-cont-desc'>
          <div>{formatMessage({ id: 'dbh_login_click_email_link_desc' })}</div>
          <div>{formatMessage({ id: 'dbh_login_register_contant_desc' })}</div>
        </div>
        <div className='login-cont-from-btn'>
          <Button type="link" onClick={onBack}>
            {formatMessage({ id: 'dbh_login_goback_tologin' })}
          </Button>
        </div>
      </div>
    </div>
  )
}
